module.exports = __webpack_public_path__ + "d49ffb138.jpg";